<template>
  <Modal
    :loading="loading"
    hideClose
    maxWidth="800"
    persistent
    @close="close"
    v-model="showTOS"
  >
    <template v-slot:title>
      <h2>Terms of Service</h2>
    </template>
    <template v-slot:content>
      <p class="tos-overflow">{{ tosText }}</p>
    </template>
    <template v-slot:actions>
      <v-btn-secondary @click="logout">Logout</v-btn-secondary>

      <v-btn-primary @click="acceptTOS">Accept</v-btn-primary>
    </template>
  </Modal>
</template>

<script setup>
import { useRootStore } from '../stores/root';
import { getLatestOrgTOS } from '../helpers/getLatestOrgTOS';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import Modal from './Modal.vue';
import { Hub } from 'aws-amplify';
import { addTOSAcknowledgement } from '../helpers/addTOSAcknowledgement';
const emit = defineEmits(['close']);
const store = useRootStore();
const { orgId, userId } = storeToRefs(store);
const showTOS = ref(false);
const currentVersion = ref(0);
const tosText = ref('');
const router = useRouter();
const loading = ref(false);

async function acceptTOS() {
  loading.value = true;
  await addTOSAcknowledgement(orgId.value, userId.value, currentVersion.value);
  close();
  loading.value = false;
}

function logout() {
  loading.value = true;
  Hub.dispatch('auth', {
    event: 'signOut',
    data: {},
  });
  loading.value = false;
}

function close() {
  emit('close');
}
watch(
  orgId,
  async (v) => {
    if (!v) return;
    const latest = await getLatestOrgTOS(orgId.value);
    showTOS.value = true;
    tosText.value = latest.text;
    currentVersion.value = latest.version;
  },
  { immediate: true },
);
</script>

<style scoped>
.tos-overflow {
  overflow-y: auto;
  max-height: 500px;
}
</style>
